<template>
  <SectionTemplate
    class="overflow-hidden position-relative item"
    :container="false"
  >
    <LoadingWidget v-if="loading" class="py-0 py-md-13 py-lg-16" />

    <transition name="fade">
      <div v-if="!loading && items.length">
        <TitleWidget class="text-center"> Parceiros </TitleWidget>

        <div
          :class="{ 'mt-10': keyItems == 0 || smAndDown }"
          v-for="(item, keyItems) in items"
          :key="keyItems"
        >
          <PartnerCard v-bind="item" :left="keyItems % 2 == 0" />
        </div>
      </div>
    </transition>
  </SectionTemplate>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import SectionTemplate from "../templates/SectionTemplate.vue";
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import PartnerCard from "../cards/PartnerCard.vue";

const _config = {
  mod: "partners",
  path: "/parceiros",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    itemsPerPage: 2,
    items: [],
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        params: {
          itemsPerPage: this.itemsPerPage,
        },
      })
      .then((data) => {
        this.items = data.map(
          ({ id, img_brand, img, title, introduction }) => ({
            img_brand,
            img,
            title,
            introduction,
            to: `${this.path}/${formatToURL(title)}-${id}`,
          })
        );
      })
      .then(() => (this.loading = false));
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    SectionTemplate,
    LoadingWidget,
    TitleWidget,
    PartnerCard,
  },
};
</script>
